module.exports = __webpack_public_path__ + "static/BlueCrop-279960d811e034d8604dd20904f66583.webp";